<template>
    <div :class="['contact-link', { slim: layout.slim }]">
        <div class="image-holder">
            <img src="./../../assets/graticule.png" alt="Wireframed sphere respresenting Soletanche Bachy's offices"/>
        </div>
        <div class="text">
            <h2 v-html="layout.baseline"/>
            <div class="footer">
                <Cta
                    :type="'router-link'"
                    :to="$trl({
                        name: 'Contact',
                        params: {
                            locale: $route.params.locale
                        }
                    })"

                    class="link"
                >
                    {{layout.caption}}
                </Cta>
            </div>
        </div>
    </div>
</template>

<script>
import Cta from '@/components/Cta'
export default {
    components: {
        Cta
    },
    props: {
        layout: {
            type: Object,
            default() {}
        }
    }
}
</script>

<style lang="sass" scoped>
@import "@/styles/vars.sass"
.contact-link
    height: 610px
    margin-top: 10%
    margin-bottom: 10%
    position: relative
    @include media-breakpoint-down($hd)
        height: 360px
        margin-left: 72 / 750 * 100%
        margin-right: 72 / 750 * 100%
    @media print
        height: auto
        margin-left: 9.6%
        margin-right: 9.6%
        page-break-inside: avoid
        break-inside: avoid
        margin-top: .6cm
        margin-bottom: .6cm

    &.slim
        height: 563px
        margin-top: 0
        margin-bottom: 0
        @include media-breakpoint-down($hd)
            height: 360px
            margin-left: 72 / 750 * 100%
            margin-right: 72 / 750 * 100%
            margin-top: 10%
            margin-bottom: 10%
        @media print
            height: auto
            margin-left: 9.6%
            margin-right: 9.6%
            margin-top: 0%
            margin-bottom: 0%
        &:last-child
            margin-bottom: -348px
            z-index: 1
            @include media-breakpoint-down($hd)
                margin-bottom: -174px
            @media print
                margin-bottom: 0
.image-holder
    width: 528px
    height: 528px
    position: absolute
    z-index: -1
    top: 50%
    right: 45%
    margin-top: -264px
    @include media-breakpoint-down($hd)
        width: 286px
        height: 286px
        margin-top: -143px
    @include media-breakpoint-down($sm)
        width: 142px
        height: 142px
        margin-top: -71px
        margin-right: -71px
        right: 50%

    @media print
        display: none
    .slim &
        width: 285px
        height: 285px
        right: 66.625%
        margin-top: -142px
        @include media-breakpoint-down($hd)
            width: 286px
            height: 286px
            right: 45%
            margin-top: -143px
        @include media-breakpoint-down($sm)
            width: 142px
            height: 142px
            right: 50%
            margin-top: -71px
            margin-right: -71px
    img
        width: 100%
        height: auto
.text
    height: 100%
    display: flex
    flex-direction: column
    margin-left: 46%
    justify-content: center
    padding-top: 120px
    @include media-breakpoint-down($hd)
        margin-left: 35%
        align-items: flex-end
    @include media-breakpoint-down($sm)
        margin-left: 0%
    @media print
        display: block
        margin-left: 0
        padding-top: 0
    .slim &
        margin-left: 29.5%
        margin-right: 8%
        align-items: center
        flex-direction: row
        padding-top: 0
        @include media-breakpoint-down($hd)
            padding-top: 120px
            flex-direction: column
            margin-left: 35%
            margin-right: 0
            align-items: flex-end
        @include media-breakpoint-down($sm)
            margin-left: 0%
        @media print
            padding-top: 0
            margin-left: 0
    h2
        color: #ff2b2a
        max-width: 10em
        @include media-breakpoint-down($hd)
            padding-right: 0%
        @include media-breakpoint-down($sm)
            font-size: 35px
            padding-right: 0%
        .slim &
            flex: 1
            @include media-breakpoint-down($hd)
                flex: auto
.footer
    margin-top: 8%
    @media print
        margin-top: .3cm
        a
            position: relative
            overflow: visible
            border: none
        a:after
            content: "https://www.soletanche-bachy.com" attr(href)
            font-size: 12px
            font-weight: normal
    .slim &
        flex: 1
        margin-top: 0
        @include media-breakpoint-down($hd)
            margin-top: 8%
            flex: auto
            @media print
                margin-top: .3cm
.cta
    border: 1px solid #e5e5e5
    margin-left: 150px
    white-space: nowrap
    @include media-breakpoint-down($hd)
        margin-left: auto
    @include media-breakpoint-down($sm)
        /deep/ .default,
        /deep/ .hover
            font-size: 11px
        /deep/ svg
            width: 10px
            height: 8px
    @media print
        margin-left: 0
    .slim &
        margin-left: 0
        @include media-breakpoint-down($hd)
            margin-left: auto
</style>
